$.namespace("common.footer");

common.footer = {
  popupFlag: false,
  tabBarHiddenUrlFlag: false,
  tabBarHiddenUrlList: [],
  tabBarFocusType: {
    NONE: "none",
    DRAWER: "drawer", // item01
    SEARCH: "search", // item02
    HOME: "home", // item03
    MYPAGE: "mypage", // item04
    RECENT: "recent", // item05
  },

  init: function () {
    common.footer.tabBarHiddenUrlList = [
      "/goods/getGoodsDetail.do",
      "/cart/getCart.do",
      "/cart/cart.do",
      "/order/getOrderComplete.do",
      "/order/getOrderCompleteFail.do",
      "/orderGiftCard/getOrderComplete.do",
      "/order/getOrderForm.do",
      "/login/loginForm.do",
      "/mfa/web/notice.do",
      "/company/privacy.do",
      "/company/locationPolicy.do",
      "/goods/getTodayDeliveryNoti.do",
      "/live/broadcast/gate.do",
      "/mypage/getGdasEvalForm.do",
      "/mypage/olivevoice/olivevoiceSurvey.do",
      "/company/termsVer.do",
      "/customer/reqChangePasswd.do",
      "/customer/agreeTerm.do",
      "/customer/clearRestingCustomerNew.do",
      "/mypage/getMygdasThema.do",
      "/mypage/getMygdasThemaDetail.do",
      "/mypage/getGdasList.do?goodsNo=",
      "/curation/getCurationPop.do",
      "/goods/getGdasPhotoListPop.do",
      "/goods/getGdasPhotoDetailPop.do",
      "/server_notice/server_error.html",
      "/event/newlive/getEventDetail.do",
      "/giftCardGuide/getGiftCardRefuse.do",
      "/myGiftCard/getMyGiftCardReg.do",
      "/myGiftCard/getMyGiftCardRegInfo.do",
      "/delivery-option-change/accept-form.do",
      "/delivery-option-change/accept-complete.do",
      "/setting/personalizedAd.do"
    ];

    common.footer.hideTabBarByUrl();
  },
  hideTabBarByUrl: function () {
    var currentPath = location.pathname.substring("/m".length);
    var privacyVerYn = currentPath.includes("/company/privacyVer"); // 개인정보 처리방침 예외처리

    if (
      common.footer.tabBarHiddenUrlList.indexOf(currentPath) < 0 &&
      privacyVerYn === false
    ) {
      if (location.search.indexOf("gdasReport=Y") >= 0) {
        // 리뷰 신고하기 페이지 처리
        common.footer.setLocationChangedEvent();
        common.footer.handleTabBar(false, false);
        common.footer.tabBarHiddenUrlFlag = true;

        return;
      }

      // hidden url에서는 하단바 숨김/노출 observer 저장 안 함
      common.footer.setPopupStyleObserver($("#pop-full-wrap")[0]);
      common.footer.setPopupStyleObserver(
        $("#mSearchWrapper")[0],
        common.footer.tabBarFocusType.SEARCH
      );

      var $popFullWraps = $(".popFullWrap");
      if ($popFullWraps.length > 0) {
        $popFullWraps.each(function (i, el) {
          common.footer.setPopupStyleObserver(el);
        });
      }

      var $popLayerWraps = $(".popLayerWrap");
      if ($popLayerWraps.length > 0) {
        $popLayerWraps.each(function (i, el) {
          common.footer.setPopupStyleObserver(el);
        });
      }

      var $popupBottomUp = $("#popupBottomUp");
      if ($popupBottomUp.length > 0) {
        $popupBottomUp.each(function (i, el) {
          common.footer.setPopupStyleObserver(el);
        });
      }

      var $oyLayerWrap = $(".oyLayerWrap");
      if ($oyLayerWrap.length > 0) {
        $oyLayerWrap.each(function (i, el) {
          common.footer.setPopupStyleObserver(el);
        });
      }

      var $eventDimLayer = $("#eventDimLayer");
      if ($eventDimLayer.length > 0) {
        $eventDimLayer.each(function (i, el) {
          common.footer.setPopupStyleObserver(el);
        });
      }

      var $crtPopFullWrap = $(".crtPopFullWrap");
      if ($crtPopFullWrap.length > 0) {
        $crtPopFullWrap.each(function (i, el) {
          common.footer.setPopupStyleObserver(el);
        });
      }

      if (currentPath.includes("/amusement/festaArchived.do")) {
        var $pageFullWrap = $(".pageFullWrap");
        if ($pageFullWrap.length > 0) {
          $pageFullWrap.each(function (i, el) {
            common.footer.setPopupStyleObserver(el);
          });
        }
      }

      if (currentPath.includes("/getEventDetail.do")) {
        var $oyFullLayer = $(".oyFullLayer");
        if ($oyFullLayer.length > 0) {
          $oyFullLayer.each(function (i, el) {
            common.footer.setPopupStyleObserver(el);
          });
        }
      }

      if (currentPath.includes("/getGiftCardGuide.do")) {
        var $giftCardDetailPop = $(".giftCardDetailPop");
        if ($giftCardDetailPop.length > 0) {
          $giftCardDetailPop.each(function (i, el) {
            common.footer.setPopupStyleObserver(el);
          });
        }
      }

      if (currentPath.includes("/myPageMain.do")) {
        var $mContainer = $("#mContainer");
        if ($mContainer.length > 0) {
          $mContainer.each(function (i, el) {
            common.footer.setPopupStyleObserver(el);
          });
        }
      }

      if (currentPath.includes(("/getSaleList.do"))) {
        var $saleSortPop = $("#sale-sort");
        if ($saleSortPop.length > 0) {
          $saleSortPop.each(function (i, el) {
            common.footer.setPopupClassObserver(el);
          });
        }
      }

      common.footer.handleTabBar(true, false);
      common.footer.tabBarHiddenUrlFlag = false;
      common.footer.setTabBarFocusByUrl();
    } else {
      common.footer.handleTabBar(false, false);
      common.footer.tabBarHiddenUrlFlag = true;
    }
  },
  isPopupObserverWork: function () {
    // 하단바가 없는 페이지에서는 팝업 observer 동작 안 하도록
    // 해당 화면 확인
    return $(".shippFullpop").hasClass("on") !== true
        && !$("#locationPop").hasClass("on");
  },
  setPopupStyleObserver: function ($element, type) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.attributeName === "style" &&
          mutation.oldValue &&
          mutation.oldValue.indexOf("display") < 0
        ) {
          return;
        }

        var currentDisplay = $(mutation.target).css("display");
        if (
          currentDisplay &&
          mutation.oldValue &&
          mutation.oldValue.indexOf(currentDisplay) >= 0
        ) {
          // 이전 display랑 똑같으면 안 보냄
          return;
        }

        if (!common.footer.isPopupObserverWork()) {
          return;
        }

        var elementId = $(mutation.target).attr("id");

        if(elementId === "mContainer"){
          if (currentDisplay === "block") {
            common.footer.popupFlag = false;

            common.footer.handleTabBar(true);
          } else {
            common.footer.popupFlag = true;

            common.footer.handleTabBar(false);
          }
        } else{
          if (currentDisplay === "none") {
            common.footer.popupFlag = false;

            if ($("#mSearchWrapper").css("display") !== "block") {
              // 검색 화면에서 장바구니 옵션 열렸다가 닫힐 때 하단바 노출 안함
              common.footer.handleTabBar(true);
            }

            if (type === common.footer.tabBarFocusType.SEARCH) {
              common.footer.setTabBarFocusByUrl();
            }
          } else {
            common.footer.popupFlag = true;

            common.footer.handleTabBar(false);
          }
        }
      });
    });

    var config = {
      attributes: true,
      attributeFilter: ["style"],
      attributeOldValue: true,
    };

    if ($element instanceof Node) {
      observer.observe($element, config);
    }
  },
  setPopupClassObserver: function ($element) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if(mutation.oldValue === ""){
          return;
        }
        var currentClass = $(mutation.target).attr("class");

        if(currentClass === "enter"){
          common.footer.popupFlag = true;

          common.footer.handleTabBar(false);
        } else{
          common.footer.popupFlag = false;

          common.footer.handleTabBar(true);
        }
      });
    });

    var config = {
      attributes: true,
      attributeFilter: ["class"],
      attributeOldValue: true,
    };

    if ($element instanceof Node) {
      observer.observe($element, config);
    }
  },
  setNativeTabBarVisibility: function (isShow) {
    if (!common.app.appInfo.isapp) {
      return;
    }

    if (!isShow) {
      $("#mFooter").addClass("no-native-bar");
    } else {
      $("#mFooter").removeClass("no-native-bar");
    }

    var message = {
      name: "JS_BRIDGE_MAIN",
      callFunctionName: "setNativeTabBarVisibility",
      json: {
        isShow,
      },
    };

    var encodedParams = encodeURIComponent(JSON.stringify(message));

    var aosFuncNm1 = "JS_BRIDGE_MAIN";
    var aosFuncNm2 = "setNativeTabBarVisibility";
    var iosFuncNm = "JS_BRIDGE_MAIN";

    common.app.sendAppInterface(
      aosFuncNm1,
      aosFuncNm2,
      iosFuncNm,
      encodedParams
    );
  },
  handleTabBar: function (isShow, animated) {
    if(common.app !== undefined  && common.app.appInfo !== undefined && common.app.appInfo.isapp){
      if(isShow){
        $("body").addClass("onApp");
        $("#mFooter").removeClass("no-native-bar");
        $(".fvPop_search").addClass("on");
      } else{
        $("body").removeClass("onApp");
        $("#mFooter").addClass("no-native-bar");
        $(".fvPop_search").removeClass("on");
      }

      if(common.app.compareVersion(common.app.appInfo.appver, "3.15.0") === ">"){
        common.app.setNativeTabBar(isShow, animated);
      } else{
        common.footer.setNativeTabBarVisibility(isShow);
      }
    } else{
      if(isShow){
        $("#footerTab").addClass("on");
        $("#footerTab").css("display", "block");
        $(".fvPop_search").addClass("on");
      } else{
        $("#footerTab").removeClass("on");
        $("#footerTab").css("display", "none");
        $(".fvPop_search").removeClass("on");
      }
    }
  },
  setTabBarFocusByUrl: function () {
    var currentPath = location.pathname.substring("/m".length);

    var type = common.footer.tabBarFocusType.NONE;

    if (currentPath.indexOf("/main/main.do") >= 0) {
      type = common.footer.tabBarFocusType.HOME;
    }

    if (currentPath.indexOf("/mypage/") >= 0) {
      type = common.footer.tabBarFocusType.MYPAGE;
      if (currentPath.indexOf("/mypage/getRecentList.do") >= 0) {
        type = common.footer.tabBarFocusType.RECENT;
      }
    }

    if (currentPath.indexOf("/display/getSCategoryList.do") >= 0) {
      type = common.footer.tabBarFocusType.DRAWER;
    }

    if (currentPath.indexOf("/search/getSearchMain.do") >= 0) {
      type = common.footer.tabBarFocusType.SEARCH;
    }

    common.footer.setNativeTabBarFocus(type);
  },
  setNativeTabBarFocus: function (type) {
    if (!common.app.appInfo.isapp) {
      return;
    }

    var hasInterface = common.footer.setTabSelection(type);

    if (hasInterface) {
      return;
    }

    var message = {
      name: "JS_BRIDGE_MAIN",
      callFunctionName: "setNativeTabBarFocus",
      json: {
        type,
      },
    };

    var encodedParams = encodeURIComponent(JSON.stringify(message));

    var aosFuncNm1 = "JS_BRIDGE_MAIN";
    var aosFuncNm2 = "setNativeTabBarFocus";
    var iosFuncNm = "JS_BRIDGE_MAIN";

    common.app.sendAppInterface(
      aosFuncNm1,
      aosFuncNm2,
      iosFuncNm,
      encodedParams
    );
  },
  setNativeTabBarFocusCallback: function (type, callbackFunc) {
    if (!common.app.appInfo.isapp) {
      return;
    }

    var hasInterface = common.footer.setTabSelection(type);

    if (hasInterface) {
      return;
    }
    
    var message = {
      name: "JS_BRIDGE_MAIN",
      callFunctionName: "setNativeTabBarFocus",
      json: {
        type,
      },
    };

    var encodedParams = encodeURIComponent(JSON.stringify(message));

    var aosFuncNm1 = "JS_BRIDGE_MAIN";
    var aosFuncNm2 = "setNativeTabBarFocus";
    var iosFuncNm = "JS_BRIDGE_MAIN";

    common.app.sendAppInterface(
      aosFuncNm1,
      aosFuncNm2,
      iosFuncNm,
      encodedParams
    );

    if (callbackFunc) callbackFunc();
  },
  setLiveNudgeVisibility: function (isShow) {
    if (!common.app.appInfo.isapp) {
      return;
    }

    if ($("#ulShopAlim").is(":visible") !== true) {
      return;
    }

    var message = {
      name: "JS_BRIDGE_MAIN",
      callFunctionName: "setLiveNudgeVisibility",
      json: {
        isShow,
      },
    };

    var encodedParams = encodeURIComponent(JSON.stringify(message));

    var aosFuncNm1 = "JS_BRIDGE_MAIN";
    var aosFuncNm2 = "setLiveNudgeVisibility";
    var iosFuncNm = "JS_BRIDGE_MAIN";

    common.app.sendAppInterface(
      aosFuncNm1,
      aosFuncNm2,
      iosFuncNm,
      encodedParams
    );
  },
  hasNativeTabbarInterface: function () {
    if (
      window.JS_BRIDGE_MAIN &&
      window.JS_BRIDGE_MAIN["setNativeTabBarVisibility"]
    ) {
      return true;
    }

    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers["JS_BRIDGE_MAIN"]
    ) {
      return true;
    }

    return false;
  },
  pressCheckMainSearch4: function (e, a) {
    if ($(a).val() == "") {
      $(a).focus();
      return;
    }
    if (event.keyCode == 13) {
      var giftYn = common._giftCardCheck($(a).val());

      var keyword = $(a).val();

      if(keyword != undefined) {
        keyword = keyword.replaceAll("\"", "");
        keyword = keyword.replaceAll("\'", "");
        keyword = keyword.replaceAll("'", "");
        keyword = keyword.replaceAll("’","");
        keyword = keyword.replaceAll("&#34;", "");
        keyword = keyword.replaceAll("&#39;", "");
        keyword = keyword.replaceAll("\\\\", "");
      }

      location.href =
        _baseUrl +
        "search/getSearchMain.do?query=" +
        encodeURIComponent(keyword) +
        "&giftYn=" +
        giftYn;

      $("#mSearchWrapper").hide();
      $("#mWrapper").attr("style", "display: block");
    } else {
      return false;
    }
  },
  isFooterPage() {
    // 하단바 노출되는 페이지인지 판단
    // true: 원래 노출되는 페이지
    // false: 원래 숨김 되는 페이지
    var currentPath = location.pathname.substring("/m".length);
    var privacyVerYn = currentPath.includes("/company/privacyVer"); // 개인정보 처리방침 예외처리

    return (
      common.footer.tabBarHiddenUrlList.indexOf(currentPath) < 0 &&
      privacyVerYn === false
    );
  },
  setLocationChangedEvent() {
    if (!common.app.appInfo.isapp) {
      return;
    }

    // 리뷰 신고하기에서 뒤로 가기 확인
    if (
      (location.pathname.includes("/mypage/getReviewerGdasDetail.do") ||
        location.pathname.includes("/mypage/getReviewerProfile.do")) &&
      location.search.indexOf("gdasReport=Y") >= 0
    ) {
      window.addEventListener("popstate", function (event) {
        common.footer.hideTabBarByUrl();
      });
    }
  },
  tabbarTracking(eventName, clickSource, tabbarName) {
    common.app.sendEventForFirebase('tabbar_click', {tabbar_nm: tabbarName});
    common.app.callTrackEvent('af_tabbar_click', {af_tabbar_nm: tabbarName});

    var eventProperties = {
      entry_source: "탭바",
      click_source: clickSource,
    };

    callLogEvent(eventName, eventProperties);
  },
  setTabSelection(type) {

    var id = common.footer.tabBarFocusType.NONE;

    if (type === common.footer.tabBarFocusType.MYPAGE) {
      id = "my";
    } else if (type === common.footer.tabBarFocusType.DRAWER) {
      id = "category"
    }

    var tabSelectionArgs = encodeURIComponent(JSON.stringify({selectedTabID: id}));

    if (window.ui && window.ui.setTabSelection) {
      window.ui.setTabSelection(tabSelectionArgs);
      return true;
    } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.setTabSelection && window.webkit.messageHandlers.setTabSelection.postMessage) {
      window.webkit.messageHandlers.setTabSelection.postMessage(tabSelectionArgs);
      return true;
    }

    return false;
  }

};

$(document).ready(function () {
  common.footer.init();
});
